module.exports = __webpack_public_path__ + "static/media/malachite.448b26cf.jpg";